import { useEffect } from 'react';
import useAppDispatch from 'hooks/useAppDispatch';
import { clearFilters, getFilters, loadProducts, searchPhraseClear } from 'store/reducers/assortmentSlice';
import Flex from 'components/ui/Flex';
import ProductList from 'components/Product/ProductList';
import useAppSelector from 'hooks/useAppSelector';
import { useTranslation } from 'react-i18next';

export const SearchResult = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const {
        products,
        assortmentPageInfo,
        loading,
        categories,
        currentPathName,
        searchPhrase,
        filters,
    } = useAppSelector(({ assortment }) => assortment);

    useEffect(() => {
        dispatch(loadProducts({ page: 1 }));
        dispatch(getFilters());
    }, [dispatch, categories, currentPathName, searchPhrase]);

    useEffect(() => {
        return () => {
            dispatch(clearFilters());
            dispatch(searchPhraseClear());
        };
    }, []);

    return (
        <Flex column>
            <h2 className="px-3 f2-700">{t('searchResults')}</h2>
            <ProductList
                products={products}
                assortmentPageInfo={assortmentPageInfo}
                loading={loading}
                enableFilters={!!filters.length}
            />
        </Flex>
    );
};
